import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  stroke: "#1B7A45",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14 7.785v.552a6 6 0 1 1-3.559-5.484" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14 3.537 8 9.543l-1.8-1.8" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }